export default __webpack_public_path__ + "static/media/image3.9601afc0.jpeg";